import { autoinject } from "aurelia-dependency-injection";
import { CompanyModel } from "../../../../../../../../models/companies/company.models";
import { SystemRuleResultSummaryModel } from "../../../../../../../../models/vessels/vessel.models";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { useView } from "aurelia-framework";

@autoinject
@useView('views/pages/modules/company/tabs/social/tabs/abandonment-verification/company-abandonment-verification.html')
export class CompanyAbandonmentVerification  {

    item: CompanyModel;

    crewWelfareRuleCodes: { [index: string]: { color: string, icon: string, isAbandonment: boolean } } = {
        "S51": { color: "warning", icon: "info-exclamation-mark", isAbandonment: true },
        "S52": { color: "danger", icon: "close", isAbandonment: true },
        "-": { color: "success", icon: "tick-circled", isAbandonment: true }
    };

    activate(item: CompanyModel) {
        this.item = item;
    }

    getColorOfCrewWelfare(info: SystemRuleResultSummaryModel) {
        const item = this.crewWelfareRuleCodes[info.code];
        if (item){
            if(this.item.hasCompanyAbandonmentofSeafarersOlderThanFiveYears && info.code === "S51"){
                return this.crewWelfareRuleCodes["-"].color;
            }
            return item.color;
        }
        return "";
    }

    getIconOfCrewWelfare(info: SystemRuleResultSummaryModel) {
        const item = this.crewWelfareRuleCodes[info.code];
        if (item){
            if(this.item.hasCompanyAbandonmentofSeafarersOlderThanFiveYears && info.code === "S51") {
                return this.crewWelfareRuleCodes["-"].icon;
            }
            return item.icon;
        }
        return "";
    }                            

    @computedFrom(Reflection.getPropertyPath<CompanyAbandonmentVerification>(z => z.item),
    Reflection.getPropertyPath<CompanyAbandonmentVerification>(z => z.item.hasCompanyAbandonmentofSeafarersOlderThanFiveYears),
    Reflection.getPropertyPath<CompanyAbandonmentVerification>(z => z.item.hasS51),
    Reflection.getPropertyPath<CompanyAbandonmentVerification>(z => z.item.hasS52) ) 
    get crewWelfareRules(): SystemRuleResultSummaryModel[] {
        if (this.item) 
        {
            const result = [];
            if (this.item.hasCompanyAbandonmentofSeafarersOlderThanFiveYears)
            {             
                 result.push({
                        code: "S51",
                        display: "Abandonment of Seafarers – Company – No reported case in the last 5 years",
                        description: "There is no record of this company being associated with an Abandonment of Seafarers case in the last 5 years as reported by the International Labour Organization (ILO)."
                });     
            }

            else 
            {
                if (this.item.hasS51)
                {
                    result.push({
                        code: "S51",
                        display: "Abandonment of Seafarers - Company - Closed",
                        description: "This company has previously been associated with an Abandonment of Seafarers case as reported by the International Labour Organization (ILO). This case is now RESOLVED as per ILO Abandonment of Seafarers database."
                    });
                                        
                }
            }

            if (this.item.hasS52) {
                    result.push({
                        code: "S52",
                        display: "Abandonment of Seafarers - Company - Open",
                        description: "This company has previously been associated with an Abandonment of Seafarers case as reported by the International Labour Organization (ILO). This case is still OPEN or IN DISPUTE as per ILO Abandonment of Seafarers database."
                });
            }

            if (!this.item.hasS51 && !this.item.hasS52 && !this.item.hasCompanyAbandonmentofSeafarersOlderThanFiveYears) {
                result.push({
                        code: "-",
                        display: "Abandonment of Seafarers – Company – No reported case",
                        description: "There is no record of this company being associated with an Abandonment of Seafarers case as reported by the International Labour Organization (ILO)."
                });
            }
            
            return result;
        }
        return [];
    }
}